import { RadioGroupItem } from '@repo/videa-components/src/ui/radio-group';
import { Label } from '@repo/videa-components/src/ui/label';

export const PracticePreferencesRadio = (props: {
  value: number;
  label: string;
}) => {
  return (
    <div className="vai-flex vai-items-center vai-space-x-3">
      <RadioGroupItem
        value={String(props.value)}
        id={`radio-${props.value}`}
        className="vai-h-5 vai-w-5"
      />
      <Label htmlFor={`radio-${props.value}`} className="!vai-text-base">
        {props.label}
      </Label>
    </div>
  );
};
